module.exports = __webpack_public_path__ + "img/ic_member_month.b34974b4.png";